var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { defaultConfig, Image, useRecipe } from "@chakra-ui/react";
import React from "react";
// Storing these in an array. Chakra expects these breakpoints, so they should never change
// We use these to know which order the breakpoints are in. useTheme returns an object which isn't ordered
var breakpointKeys = ["base", "sm", "md", "lg", "xl", "2xl"];
/**
 * Takes in a responsive values object, array or string and converts it to a responsive array
 */
function convertToResponsiveArray(responsiveValues) {
    var responsiveArray = [];
    if (typeof responsiveValues === "string") {
        responsiveArray.push(responsiveValues);
    }
    else if (!Array.isArray(responsiveValues)) {
        Object.keys(responsiveValues).forEach(function (key) {
            responsiveArray[breakpointKeys.indexOf(key)] =
                responsiveValues[key] || "";
        });
    }
    else {
        responsiveArray = responsiveValues;
    }
    return responsiveArray;
}
/**
 * Takes in a src, htmlWidth and htmlHeight, and builds a <picture> with the appropriate <source>
 * responsive images.
 * Note: The src, htmlWidth and htmlHeight need to be the exact same shape (all define the same set of responsive breakpoints)
 */
function ResponsiveImage(props) {
    var _a, _b;
    var breakpoints = (_b = (_a = defaultConfig.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) !== null && _b !== void 0 ? _b : {};
    var recipe = useRecipe({ key: "ResponsiveImage" });
    var styles = recipe();
    var src = props.src, htmlHeight = props.htmlHeight, htmlWidth = props.htmlWidth, rest = __rest(props, ["src", "htmlHeight", "htmlWidth"]);
    var mergedStyle = __assign(__assign({}, styles), rest);
    // Convert all responsive values into array syntax
    var responsiveHtmlWidth = convertToResponsiveArray(htmlWidth);
    var responsiveHtmlHeight = convertToResponsiveArray(htmlHeight);
    var responsiveSrc = convertToResponsiveArray(src);
    return (_jsxs("picture", { children: [responsiveSrc.map(function (srcSet, index) {
                var media;
                if (index < responsiveSrc.length - 1) {
                    media = "(max-width: calc(".concat(breakpoints[breakpointKeys[index + 1]], " - 1px))");
                }
                else {
                    media = "(min-width: ".concat(breakpoints[breakpointKeys[index]], ")");
                }
                return (_jsx(React.Fragment, { children: src ? (_jsx("source", { media: media, srcSet: srcSet, width: responsiveHtmlWidth[index], height: responsiveHtmlHeight[index] })) : ("") }, media));
            }), _jsx(Image, __assign({ src: responsiveSrc[0], maxHeight: responsiveHtmlHeight[0], maxWidth: responsiveHtmlWidth[0], fit: "contain" }, mergedStyle))] }));
}
export { ResponsiveImage };
